import { IconButton, IconButtonProps } from "@mui/material"
import styled from "styled-components"
import MoreDetailsHoverIcon from "./icons/MoreDetailsHoverIcon"
import MoreDetailsIcon from "./icons/MoreDetailsIcon"

const StyledIconButton = styled(IconButton)`
  padding: 2px;
  svg {
    &:first-child {
      display: block;
    }
    &:nth-child(2) {
      display: none;
    }
  }
  &:hover {
    svg {
      &:first-child {
        display: none;
      }
      &:nth-child(2) {
        display: block;
      }
    }
  }
  cursor: pointer;
`
type MoreDetailsButtonProps = IconButtonProps & {
  variant?: "normal" | "dark" | "light"
}

const MoreDetailsButton = ({ ...props }: MoreDetailsButtonProps) => {
  return (
    <StyledIconButton {...props}>
      <MoreDetailsIcon />
      <MoreDetailsHoverIcon />
    </StyledIconButton>
  )
}

export default MoreDetailsButton
